/**
 * In-memory signal for in-place sibling navigation (FileDetail ok tuşları).
 *
 * location.state KULLANMIYORUZ: tarayıcı history.state'i F5'te koruduğu için
 * stale "inPlaceSiblingNav" değeri yenilemede yanlışlıkla tetikleniyordu.
 * Bu modül bayrağı reload'da sıfırlanır (modül yeniden yüklenir), tam da istediğimiz davranış.
 *
 * Bayrak tek bir senkron navigasyon için true kalır; mevcut render + effect'ler
 * (ProjectDetail ve FileDetail) okuduktan sonra microtask sonunda otomatik temizlenir.
 */
let pending = false;
let clearScheduled = false;

export function markInPlaceSiblingNav(): void {
  pending = true;
  if (!clearScheduled) {
    clearScheduled = true;
    // Senkron effect'ler bittikten sonra temizle (setTimeout(0) effect'lerden sonra çalışır).
    setTimeout(() => {
      pending = false;
      clearScheduled = false;
    }, 0);
  }
}

export function peekInPlaceSiblingNav(): boolean {
  return pending;
}
